export const SET_USER_INTENT_PROMPT = 'SET_USER_INTENT_PROMPT';
export const SET_SALES_FORCE_LEAD = 'SET_SALES_FORCE_LEAD';
export const SET_SALES_FORCE_PROCESSED = 'SET_SALES_FORCE_PROCESSED';

export const setUserIntentPromptVisible = visible => ({
  type: SET_USER_INTENT_PROMPT,
  meta: {
    visible,
  },
});

export const setSalesForceLead = params => ({
  type: SET_SALES_FORCE_LEAD,
  meta: {
    xmApi: true,
    method: 'post',
    uri: '/webapi/provision/xm/product-event/sales-intent',
    params,
  },
});

export const setSalesForceProcessed = isProcessed => ({
  type: SET_SALES_FORCE_PROCESSED,
  meta: {
    isProcessed,
  },
});
